import * as Sentry from "@sentry/nextjs";
import { notFound } from "next/navigation";

import { env } from "@/common/env/server.mjs";

export interface GoToNotFoundOptions {
  feature?: string;
  level?: Sentry.SeverityLevel;
  reason?: string;
  tags?: Record<string, string>;
}

export const goToNotFound = ({ feature = "notFoundRedirect", level = "info", reason, tags }: GoToNotFoundOptions) => {
  const error = new Error("Page not found");

  if (env.NODE_ENV === "development") {
    console.error(error, { level, feature, reason });
  }

  Sentry.captureException(error, {
    level,
    tags: { ...tags, feature },
    extra: { reason },
  });

  return notFound();
};
